<script setup lang="ts">
import type { BlockItemProps } from '~/components/Block/BlockItem.vue';

// PROPS
defineProps<{
    title?: string;
}>();

// COMPOSABLES
const { tt, tn } = useTypedI18n();
const { soldVehicles, countries, companies, employees } = useFleequidStats();

// DATA
const items = computed<BlockItemProps[]>(() => [
    {
        icon: 'fl:purchase',
        title: tn(soldVehicles.value),
        description: tt('block.stats.purchase'),
    },
    {
        icon: 'fl:markets',
        title: tn(countries.value),
        description: tt('block.stats.markets'),
    },
    {
        icon: 'fl:team',
        title: tn(employees.value),
        description: tt('block.stats.team'),
    },
    {
        icon: 'fl:registrations',
        title: tn(companies.value),
        description: tt('block.stats.registrations'),
    },
]);
</script>

<template>
    <BlockTwoCol :title="tt('block.stats.title')" :items="items" />
</template>
